<template>
  <div class="TmMultiImgEdit myPriceTagEdit">
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>

        <attr-row
          :label="$t('lcd.Editor.PriceTag Name') + ' : ' + conf.priceTagName"
        ></attr-row>

        <attr-row
          :label="$t('lcd.Editor.PriceTag Id') + ' : ' + conf.priceTagId"
        ></attr-row>

        <attr-row :label="$t('lcd.Editor.Position and Size')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              :disabled="true"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              :disabled="true"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
        </attr-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";
export default {
  name: "TumengMultiImgEdit",
  components: {
    AttrRow,
  },
  data() {
    return {
      state: store.state,
      goodsInfo: {
        id: 1,
        name: "",
      },
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
    };
  },

  computed: {
    conf() {
      return store.state.activeComponent;
    },
  },
  created() {
    if (this.state.programInfo.pages[this.state.currentPageIdx].goodsInfo) {
      // this.goodsInfo = this.state.programInfo.pages[this.state.currentPageIdx].goodsInfo
    } else {
      this.state.programInfo.pages[this.state.currentPageIdx].goodsInfo = {
        name: "",
        id: null,
      };
    }
  },
  methods: {
    selectGoods() {
      store.SET_SELECT_GOODS_OPERATION("ADD_GOODS");
      store.updateSelectGoodsDialogVisible(true);
    },
    handleClickImg(index) {
      if (this.conf.imgList.length > 1) {
        this.conf.imgList.splice(index, 1);
      } else {
        this.$message({
          type: "warning",
          message: "至少需要一张图片",
          duration: 2000,
        });
      }
    },
    handleClickAddImg() {
      store.SET_SELECT_IMG_OPERATION("ADD_IMAGE");
      store.updateSelectImgDialogVisible(true);
    },
    createImg() {
      console.log("21");
      setTimeout(() => {
        this.$emit(
          "createImg",
          this.state.programInfo.pages[this.state.currentPageIdx].goodsInfo.id,
          this.conf.priceTagList[0].priceTagId,
          this.conf.componentId
        );
      }, 500);
    },

    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (confX > this.canvasWidth - this.conf.width) {
        confX = this.canvasWidth - this.conf.width;
      }
      if (confX < 0) {
        confX = 0;
      }
      this.conf.left = confX;
    },
    changeRangeY(e) {
      let confY = +e;
      if (confY > this.canvasHeight - this.conf.height) {
        confY = this.canvasHeight - this.conf.height;
      }
      if (confY < 0) {
        confY = 0;
      }
      this.conf.top = confY;
    },
    changeRangeW(e) {
      let confW = +e;
      if (confW > this.canvasWidth - this.conf.left) {
        confW = this.canvasWidth - this.conf.left;
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = confW;
    },
    changeRangeH(e) {
      let confH = +e;
      if (confH > this.canvasHeight - this.conf.top) {
        confH = this.canvasHeight - this.conf.top;
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = confH;
    },
  },
};
</script>

<style lang="scss" scoped>
.TmMultiImgEdit {
  margin: 8px;
  color: white;
  height: calc(100% - 16px);
  overflow: auto;

  .prop-pane {
    // 添加视频按钮变宽
    > button.el-button.el-button--default.el-button--small {
      width: 100%;
    }

    // 展示图片列表的div
    .img-item {
      margin: 0 12px 8px 4px;
      padding: 4px;
      border: 1px dashed white;
      width: calc(100% - 26px);
      height: 150px;
      text-align: left;
      position: relative;

      > img {
        float: left;
      }

      > div {
        float: left;
      }

      // 删除图片按钮
      > button.el-button.el-button--default.el-button--mini.is-circle {
        padding: 0;
        position: absolute;
        right: 0;
        top: 59px;
        transform: translate(5px, -50%);
      }

      // 让图片时长输入框和图片之间有个间距
      div.el-input-number {
        margin-top: 8px;
        text-align: left;
      }

      // 图片时长输入框的增加、减小按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      > div {
        // 图片时长输入框行高
        > span {
          display: inline-block;
          line-height: 28px;
          height: 28px;
          color: #000;
        }
      }
    }
  }
  .style-pane {
    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";

    .custom-smaller-slider-btn2 {
      // 旋转和透明度的slider的拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 旋转和透明度的slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 76px);
        margin-right: 16px;
        float: left;
      }

      // 隐藏旋转和透明度数字输入框的增加、减少按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 让旋转和透明度的数字输入框便的正常
      ::v-deep input.el-input__inner {
        padding: 0;
      }

      // 指定旋转和透明度的输入框宽度宽度
      ::v-deep .el-input-number.el-input-number--mini {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
    }
  }
}
</style>
<style lang="scss">
.myPriceTagEdit .el-input-group__append,
.myPriceTagEdit .el-input-group__prepend {
  padding: 0 10px;
}
</style>